module.exports = __webpack_public_path__ + "img/normal_charge_logo.c21ab7fa.png";